import {
    MODAL_REASSIGN_USER_SET_DATA,
    MODAL_RESUME_REQUEST_SET_DATA,
    FILTER_DINAMIC_SET_DATA,
    GROUP_USER_REASING,
    IS_ACTIVE_CONCESSIONAIRE,
    LOADING_PEACE_SAFE,
    LOADING_GENERATE_DODUMENT,
    FILTER_DINAMIC_COMPARATIVE_MONTHS,
    FILTER_DINAMIC_TEAM_PERFORMANCE,
    GROUP_USER_GENERAL,
    VIEW_BUTTON_EDIT_CONTACT_CLIENT,
    NO_SHOW_COMPONENT_IN_MENU,
    NO_SHOW_MODAL,
    CHANGE_INFO_CONTAINER,
    STATE_VERIFIK,
    STATE_VERIFIK_START,
    STATE_SUMMARY_CREDIT_MODAL,
    STATE_OBSERVATION_MODAL,
    OCULTAR_SECCION,
    STATE_SUMMARY_EMPLOYEE_CREDIT_MODAL,
    STATE_RECORD_VISIT_MODAL,
    STATE_GENERAL_DATA,
} from '../actions';

const INIT_STATE = {
    modalReassignUser: null,
    modalResumeRequest: null,
    filterDinamicTable: {},
    groupUserReasign: null,
    isActiveConcessionaire: null,
    loadingPeaceAndSafe: null,
    loadingGenerateDocument: null,
    filterDinamicComparative12Months: {},
    groupUserGeneral: null,
    filterDinamicTeamPerformance: {},
    viewButtonEditContactClient: null,
    noShowViewOptionsDocumentInMenu: [],
    noShowModal: false,
    changeInfoContainer: false,
    stateVerifik: {},
    stateVerifikStart: false,
    stateSummaryCreditModal: null,
    stateSummaryEmployeeCreditModal: null,
    stateObservationModal: null,
    ocultarSeccion: false,
    stateRecordVisitModal: false,
    modalRadication: null,
    modalSubstates: null,
    ConsultRequest:false
};

const generalReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case STATE_SUMMARY_CREDIT_MODAL:
            return { ...state, ...action.payload };
        case STATE_OBSERVATION_MODAL:
            return { ...state, ...action.payload };
        case MODAL_REASSIGN_USER_SET_DATA:
            return { ...state, ...action.payload };
        case MODAL_RESUME_REQUEST_SET_DATA:
            return { ...state, modalResumeRequest: action.payload };
        case FILTER_DINAMIC_SET_DATA:
            return { ...state, ...action.payload };
        case GROUP_USER_REASING:
            return { ...state, ...action.payload };
        case IS_ACTIVE_CONCESSIONAIRE:
            return { ...state, ...action.payload };
        case LOADING_PEACE_SAFE:
            return { ...state, ...action.payload };
        case LOADING_GENERATE_DODUMENT:
            return { ...state, ...action.payload };
        case FILTER_DINAMIC_COMPARATIVE_MONTHS:
            return { ...state, ...action.payload };
        case GROUP_USER_GENERAL:
            return { ...state, ...action.payload };
        case FILTER_DINAMIC_TEAM_PERFORMANCE:
            return { ...state, ...action.payload };
        case VIEW_BUTTON_EDIT_CONTACT_CLIENT:
            return { ...state, ...action.payload };
        case NO_SHOW_COMPONENT_IN_MENU:
            return { ...state, ...action.payload };
        case NO_SHOW_MODAL:
            return { ...state, ...action.payload };
        case CHANGE_INFO_CONTAINER:
            return { ...state, ...action.payload };
        case STATE_VERIFIK:
            return { ...state, ...action.payload };
        case STATE_VERIFIK_START:
            return { ...state, ...action.payload };
        case OCULTAR_SECCION:
            return { ...state, ...action.payload };
        case STATE_SUMMARY_EMPLOYEE_CREDIT_MODAL:
            return { ...state, ...action.payload };
        case STATE_RECORD_VISIT_MODAL:
            return { ...state, ...action.payload };
        case STATE_GENERAL_DATA:
            return { ...state, ...action.payload };
        default:
            return { ...state };
    }
};

export default generalReducer;
